export interface ServiceLevelPermissions {
  sync: boolean
  sla_sellers: boolean
  regioes_slas: boolean
}

export const NO_SERVICE_LEVEL_PERMISSIONS: ServiceLevelPermissions = {
  sync: false,
  sla_sellers: false,
  regioes_slas: false,
}

export const SERVICE_LEVEL_PERMISSIONS: {
  key: keyof ServiceLevelPermissions
  label: string
  description: string
}[] = [
  {
    key: 'sync',
    label: 'Sincronização',
    description: 'Sincronizar os dados e consultar o histórico e os detalhes das execuções.',
  },
  {
    key: 'sla_sellers',
    label: 'SLA por Seller',
    description: 'Consultar e definir o prazo de envio para todas as regiões de um seller.',
  },
  {
    key: 'regioes_slas',
    label: 'Regiões & SLAs',
    description: 'Consultar e ajustar os prazos de envio por seller e região.',
  },
]

export function hasServiceLevelPermission(
  scope: {is_admin?: boolean; permissions?: ServiceLevelPermissions} | null | undefined,
  permission: keyof ServiceLevelPermissions
) {
  return scope?.is_admin === true || scope?.permissions?.[permission] === true
}
